
import { AdminLayout } from '@/components/layout/AdminLayout';
import { Outlet, useLocation } from 'react-router-dom';

export default function Admin() {
  const location = useLocation();
  const isHotelSearchRoute = location.pathname.startsWith('/admin/hotel-search');

  if (isHotelSearchRoute) {
    return <Outlet />;
  }

  return (
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  );
}
